import L from "leaflet";
import { useEffect, useState } from "react";
import "./Legend.css";
import AviationObstructionLight from '../images/Icons/V2/Legends/AviationObstructionLight.svg'
import TowerAviationObstructionLightL from '../images/Icons/V2/Legends/TowerAviationObstructionLightL.svg'
import HelihoistLightL from '../images/Icons/V2/Legends/HelihoistLightL.svg'
import HelihoistLightWithSROL from '../images/Icons/V2/Legends/HelihoistLightWithSroL.svg'
import VisibilitySensorL from '../images/Icons/V2/Legends/VisibilitySensorL.svg'
import MarineLantern5nm from '../images/Icons/V2/Legends/MarineLantern5NML.svg'
import Foghorn from '../images/Icons/V2/Legends/Foghorn.svg'
import MarineVisibilitySensorL from '../images/Icons/V2/Legends/MarineVisibilitySensorL.svg'
import AIS from '../images/Icons/V2/Legends/AIS.svg'
import OSS from '../images/Icons/V2/Legends/OSS.svg'



import BoatLandingLight from '../images/Icons/V2/Legends/BoatLandingLightL.svg'

import RACON from '../images/Icons/V2/Legends/RACONL.svg'

import HelicopterCorridorLights from '../images/Icons/V2/Legends/HelicopterCorridorLightsL.svg'

import AviationObstructionLightLowIntensity from '../images/Icons/V2/Legends/AviationObstructionLightLowIntensity.svg'
import MarineLantern2nm from '../images/Icons/V2/MarineLantern2NM.svg';
import MarineLantern3nm from '../images/Icons/V2/MarineLantern3NM.svg'



//Version 1
import VisibilitySensorIconOrange from  "../images/SVG/Ring2.svg"
import VisibilitySensorIconPurple from  "../images/SVG/Ring2Purple.svg"
import VisibilitySensorIconBlue from  "../images/SVG/Ring2Blue.svg"
import MiniTurbineIconSVG from "../images/SVG/WindTurbine.svg";
import { fetchUploadValues } from "../API";

import MRASS from '../images/Icons/V2/Legends/MRASS.svg'
import Turbine from '../images/Icons/V2/Legends/Turbine.svg'




const Legend = ({ map, mapConfig, legendHtml }) => {
    
    const [legends, setLegends] = useState();

    useEffect(()=>{
        findTypes(mapConfig).then(result => setLegends(result));
    },[])

    useEffect(() => {
        if (map) {
            if(legends){
                legendHtml.remove();
                legendHtml.onAdd = () => {
                    var div = L.DomUtil.create('div', 'info legend'),
                    grades = legends.names,
                    labels = legends.icons;

                    for (var i = 0; i < grades.length; i++) {
                        div.innerHTML +=
                        (" <img src=" +  labels[i] + " height='18' width='18'>") +" "+ grades[i] + '<br>';
                    }
                    return div;
                };
                legendHtml.addTo(map);
            }
        };

    }, [map,legends]);
    return null;
}

export default Legend;


async function findTypes(mapConfig){
    
    let legends=[];

    // {TurbineData.equipment.marineAidEquipment.marineHelicopterCorridorLights? TurIcon.DisplayMarineHelicopterCorridorLights(TurbineData): null}
    // {TurbineData.equipment.marineAidEquipment.marineFogHorn? TurIcon.DisplayFogHorn(TurbineData): null}
    // {TurbineData.equipment.marineAidEquipment.marinerRadioActivatedSoundSignals? TurIcon.DisplayMarineRadio(TurbineData): null}
    // {TurbineData.equipment.marineAidEquipment.aiS_KIT_NAS_T3? TurIcon.DisplayAIS(TurbineData): null}
    // {TurbineData.equipment.marineAidEquipment.mL5NM? TurIcon.DisplayMarineLantern5NM(TurbineData): null}
    // {TurbineData.equipment.marineAidEquipment.mL3NM? TurIcon.DisplayMarineLantern3NM(TurbineData): null}
    // {TurbineData.equipment.marineAidEquipment.mL2NM? TurIcon.DisplayMarineLantern2NM(TurbineData): null}
    // {TurbineData.equipment.marineAidEquipment.boatLandingLight? TurIcon.DisplayBoatLandingLight(TurbineData): null}
    // {TurbineData.equipment.marineAidEquipment.marineHelicopterCorridorLights? TurIcon.DisplayMarineHelicopterCorridorLights(TurbineData): null}
    // {TurbineData.equipment.marineAidEquipment.racons? TurIcon.DisplayRacon(TurbineData): null}
    // {TurbineData.equipment.marineAidEquipment.marineVisibilitySensor? TurIcon.DisplayMarineVisibilitySensor(TurbineData): null}
    

    // {TurbineData.equipment.aviationAidEquipment.towerObstructionLight? TurIcon.DisplayTowerRedDotWithX(TurbineData):null}
    // {TurbineData.equipment.aviationAidEquipment.heliHoistLight? TurIcon.DisplayHelihoistLight(TurbineData): null}
    // {TurbineData.equipment.aviationAidEquipment.heliHoistLightWithSRO? TurIcon.DisplayHelihoistLightWithSRO(TurbineData): null}
    // {TurbineData.equipment.aviationAidEquipment.aviationVisibilitySensor? TurIcon.DisplayVisibilitySensor(TurbineData): null}
    mapConfig.find(x => x.type ==="OSS") && legends.push({names:"OSS", icons:OSS})

mapConfig.find(x => x.equipment.aviationAidEquipment.aviationObstructionLight) && legends.push({names:"Aviation Obstruction Light", icons:AviationObstructionLight})
mapConfig.find(x => x.equipment.aviationAidEquipment.aviationObstructionLightLowIntensity) && legends.push({names:"Aviation Obstruction Light Low Intensity", icons:AviationObstructionLightLowIntensity})
mapConfig.find(x => x.equipment.aviationAidEquipment.towerObstructionLight) && legends.push({names:"Tower Obstruction Light", icons: TowerAviationObstructionLightL})
mapConfig.find(x => x.equipment.aviationAidEquipment.heliHoistLight) && legends.push({names:"Helihoist Light",icons:HelihoistLightL})
mapConfig.find(x => x.equipment.aviationAidEquipment.heliHoistLightWithSRO) && legends.push({names:"Helihoist Light with SRO",icons:HelihoistLightWithSROL})
mapConfig.find(x => x.equipment.aviationAidEquipment.aviationVisibilitySensor) && legends.push({names:"Aviation Visibility Sensor", icons:VisibilitySensorL})
 

 if(mapConfig.find(x => x.equipment.marineAidEquipment.mL5NM)) legends.push({names:"Marine Lantern 5NM", icons:MarineLantern5nm})
 if( mapConfig.find(x => x.equipment.marineAidEquipment.mL3NM)) legends.push({names:"Marine Lantern 3NM", icons:MarineLantern3nm})
 if ( mapConfig.find(x => x.equipment.marineAidEquipment.mL2NM) ) legends.push({names:"Marine Lantern 2NM", icons:MarineLantern2nm})

 mapConfig.find(x => x.equipment.marineAidEquipment.marineHelicopterCorridorLights) && legends.push({names:"Helicopter Cooridor Lights",icons:HelicopterCorridorLights})
 mapConfig.find(x => x.equipment.marineAidEquipment.racons) && legends.push({names:"RACON",icons:RACON})
 mapConfig.find(x => x.equipment.marineAidEquipment.boatLandingLight) && legends.push({names:"Boat Landing Light",icons:BoatLandingLight})
 mapConfig.find(x => x.equipment.marineAidEquipment.marineFogHorn) && legends.push({names:"Foghorn",icons:Foghorn})
 mapConfig.find(x => x.equipment.marineAidEquipment.marineVisibilitySensor) && legends.push({names:"Marine Visibility Sensor",icons:MarineVisibilitySensorL})
 mapConfig.find(x => x.equipment.marineAidEquipment.aiS_KIT_NAS_T3) && legends.push({names:"AIS",icons:AIS})
 mapConfig.find(x => x.equipment.marineAidEquipment.marinerRadioActivatedSoundSignals) && legends.push({names:"MRASS",icons:MRASS})
 legends.push({names:"Turbine",icons:Turbine})

 let myLegends = {

     names:[],
     icons:[]
}

 legends.map((type)=>{
     myLegends.names.push(type.names);
     myLegends.icons.push(type.icons);

 })

    return myLegends;

}


// Version 1 code below

export const Legend_Old = ({ map, mapConfig, legendHtml }) => {
    
    const [legends, setLegends] = useState(null);

    useEffect(()=>{
        findTypes_Old().then(result => setLegends(result));
    },[])


    useEffect(() => {
        if (map) {
            
            if(legends){
                // const legend = L.control({ position: "bottomright" });
                legendHtml.remove();
                legendHtml.onAdd = () => {
                    var div = L.DomUtil.create('div', 'info legend'),
                    grades = legends.names,
                    labels = legends.icons;
                    
                    for (var i = 0; i < grades.length; i++) {
                        div.innerHTML +=
                        (" <img src=" + labels[i] + " height='25' width='25'>") + grades[i] + '<br>';
                    }
                    return div;
                };
                legendHtml.addTo(map);
            }
        };

    }, [map,legends]);
    return null;
}

async function findTypes_Old(){
    
    let legends=  {
        names:[],
        icons:[],
    }

    const fetchData = async () => {
        return  await fetchUploadValues();
    }

    let wtg = await fetchData();
    const getTypes = (prop) => {
    const result = wtg.data.filter(item => item.type === prop)
    if(result.length >0) return true;
    return false;
    };

   if(getTypes("SPS")) {
       legends.names.push(" SPS") 
        legends.icons.push(VisibilitySensorIconOrange)
    }
   if(getTypes("IPS")){
    legends.names.push(" IPS") 
     legends.icons.push(VisibilitySensorIconPurple)
 }
   if(getTypes("PS")){
    legends.names.push(" PS") 
     legends.icons.push(VisibilitySensorIconBlue)
 }
   if(getTypes("IS")){
    legends.names.push(" IS") 
     legends.icons.push(MiniTurbineIconSVG)
 }
    return legends;

}